import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
import { ButtonEl } from "common/components/button";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { instrumentWithTimer } from "common/util/workflow-timing";
export function template() {
  const { contextPanelTransform } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-control-bar",
    attrs: { elref: `menuItems` }
  }, (() => {
    const overflowItems = this.helpers.getOverflowItems();
    return /* @__PURE__ */ jsx(null, null, this.attr(`controls`) && this.attr(`controls`).items.map((section, index) => {
      const { isDisabled, icon, highlightIcon, label, theme, value, slot, tooltip, elref } = section;
      return /* @__PURE__ */ jsx("div", {
        sel: ".mp-control-bar-control"
      }, tooltip && /* @__PURE__ */ jsx(TooltipEl, {
        attrs: tooltip
      }), slot ? /* @__PURE__ */ jsx("slot", {
        attrs: { name: slot }
      }) : /* @__PURE__ */ jsx(ButtonEl, {
        key: `${index}-value`,
        attrs: {
          disabled: isDisabled,
          icon,
          "highlight-icon": highlightIcon,
          value,
          theme: theme || this.attr(`theme`),
          elref
        },
        on: {
          click: instrumentWithTimer(this.helpers.handleClick)
        }
      }, label ? label : null));
    }), overflowItems.length ? /* @__PURE__ */ jsx("div", {
      sel: ".mp-control-bar-truncated-menu-container"
    }, /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        theme: SelectTheme.Tertiary,
        "show-preview-tooltip": !this.attr(`overflow-tooltip`),
        tooltip: this.attr(`overflow-tooltip`),
        icon: {
          leftIcon: this.attr(`overflow-icon`)
        },
        "icon-only": true,
        "menu-width": this.attr(`overflow-menu-width`),
        "menu-height": this.attr(`overflow-menu-height`),
        elref: `overflowMenu`,
        disabled: this.attr(`disabled`)
      },
      on: {
        change: this.helpers.handleMenuClick
      },
      props: { contextPanelTransform, sections: overflowItems }
    })) : null);
  })());
}
